import { NavigateFunction } from "react-router-dom";

import { Button } from "../../designComponents";
import theme from "../../theme";

const formatTableBody = (technicianData: any[], navigate: NavigateFunction) => {
  console.log(technicianData, "data");
  return technicianData.map((item, idx) => ({
    id: item?._id,
    serial: `${idx + 1}`,
    userName: item?.fullName,
    email: item?.user?.emailAddress,
    address: item?.contactInfo?.address1?.concat(", ", item?.contactInfo?.city),
    contact: item?.contactInfo?.phoneNumber,
    actions: (
      <Button
        variant="secondary"
        onClick={() => navigate(`${item._id}`)}
        style={{
          backgroundColor: theme.colors.blueLight,
          border: `1px solid ${theme.colors.blueLight}`,
        }}
      >
        View Details
      </Button>
    ),
  }));
};
export const getTableData = (navigate: NavigateFunction, technician: any[]) => {
  return {
    headings: [
      { key: "serial", label: "S.N" },
      { key: "userName", label: "Technician Name" },
      { key: "email", label: "Email Address" },
      { key: "address", label: "Address" },
      { key: "contact", label: "Contact Number" },
      { key: "actions", label: "Action" },
    ],
    body: formatTableBody(technician, navigate),
  };
};
